// extracted by mini-css-extract-plugin
module.exports = {"header":"Locations_header__KOWVf","flex":"Locations_flex__3ySiX","sectionTable":"Locations_sectionTable__2kC7a"};